<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimgbg" :style="{backgroundImage:'url('+pageinfo.banner+')'}"></div>
            <div class="bannertitle">
                <div class="main"><span>-{{pageinfo.title_en}}-</span></div>
                <div class="sub"><span>{{pageinfo.title}}</span></div>
            </div>
        </div>
        <div class="pagemain realwrap">
            <div class="pagenews">
                <div class="listwrap">
                    <div class="list">
                        <ul v-for="item in newslist" :key="item.id">
                            <li class="newscover">
                                <fflink linktype="image" :info="item"></fflink>
                            </li>
                            <li class="newssimple">
                                <dl>
                                    <dd class="a"><fflink :info="item"></fflink></dd>
                                    <dd class="b">{{$common.dicword('publishdate',true)+$common.basic.dateformat(item.datepublish)}}</dd>
                                    <dd class="c"><span v-html="$common.basic.strgetlen($common.langinfo(item.content,item.content_en),160)"></span></dd>
                                    <dd class="d"><fflink linktype="btn" :info="item"></fflink></dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                    <div class="ffpage">
                        <el-pagination :small="$store.getters.issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" @current-change="getnewslist()" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount">
                        </el-pagination>
                    </div>
                </div>
                <div class="top">
                    <div class="titlewrap"><div class="title"><span class="t">{{$common.dicword('recommendnews')}}</span></div></div>
                    <ul v-for="item in newstoplist" :key="item.id">
                        <li class="newscover"><fflink linktype="image" :info="item"></fflink></li>
                        <li class="newssimple">
                            <dl>
                                <dd class="a"><fflink :info="item"></fflink></dd>
                                <dd class="b">{{$common.basic.dateformat(item.datepublish)}}</dd>
                                <dd class="d"><fflink linktype="btn" :info="item"></fflink></dd>
                            </dl>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'newslist',
        data() {
            return {
                res: {},
                pageinfo: {},
                newslist: [],
                newstoplist: []
            };
        },
        methods: {
            getnewslist: function () {
                this.$common.fetch({ 'act': 'tc_news', 'exts': 'page=' + (this.res.cpage || '1') }, res => {
                    this.$common.each(res.infodatanews, (item) => {
                        item.x_url = res.infodatanewscatalog.url + '/' + item.id;
                        item.x_len = 60;
                        item.x_btn = this.$common.dicword('viewdetail') + '>>';
                        item.cover = item.imgs;
                    });

                    this.$common.each(res.infodatanewstop, (item) => {
                        item.x_url = res.infodatanewscatalog.url + '/' + item.id;
                        item.x_len = 26;
                        item.cover = item.imgs;

                        item.x_btn = this.$common.dicword('viewdetail') + '>>';
                    });
                    this.pageinfo = res.infodatanewscatalog;
                    this.newslist = res.infodatanews;
                    this.newstoplist = res.infodatanewstop;
                    this.res = res;
                    this.isdetail = false;
                });
            }
        },
        mounted() {

            this.getnewslist();
        }
    }
</script>
